import * as React from "react"
import TextInput from "../TextInput";
import * as _ from "lodash";
import IDietRecallMealItem, {IDietRecallFoodOption} from "../../models/IDietRecallMealItem";
import AppUtils from "../../utils/AppUtils";
import TimePicker from "../TimePicker";
import CustomSelect from "../CustomSelect";
import {AppConstants} from "../../utils/AppConstants";
import TemplatedList from "../TemplatedList";
import IDishCatalogueResponse from "../../models/maverick/IDishCatalogueResponse";

/**
 * Created by aditya on 28/06/18.
 */

export enum MEAL_DAYS {
    "WEEKEND" = "WEEKEND",
    "WEEKDAY" = "WEEKDAY"
}

export interface DietRecallItemEditorProps {
    consultationType?: string,
    item: IDietRecallMealItem[];
    onDataChange: (update: IDietRecallMealItem[]) => any,
    fetchDishByDishName?: (input: string) => Promise<IDishCatalogueResponse[]>;
    allSelectedMealSlots?: IDietRecallMealItem[];
}

class DietRecallItemEditor extends React.Component<DietRecallItemEditorProps> {
    constructor(props: DietRecallItemEditorProps) {
        super(props)
    }

    updateMealName = (selectedMeal: string) => {
        let mealItems = [ ...this.props.item ];
        _.map(mealItems, (mealItem) => {
            mealItem.mealType = selectedMeal;
        })
        this.props.onDataChange(mealItems);
    }

    updateInsight = (evt: any) => {
        let mealItems = [ ...this.props.item ];
        _.map(mealItems, (mealItem) => {
            mealItem.insight = evt.target.value;
        })
        this.props.onDataChange(mealItems);
    }

    updateMealTime = (time: string, mealDay: MEAL_DAYS) => {
        let mealItems = [ ...this.props.item ];
        _.map(mealItems, (mealItem) => {
            if (mealItem.day === mealDay) {
                mealItem.time = AppUtils.getTimeInSeconds(time)
            }
        })
        this.props.onDataChange(mealItems)
    }

    getMealTime = (slot: MEAL_DAYS) => {
        let item = this.props.item.filter(item => item.day === slot);
        let time = item.length ? item[0].time : null;
        return time;
    }

    onWeekdayFoodOptionsRemove = (index: number) => {
        let mealItems = [ ...this.props.item ];
        _.map(mealItems, (mealItem) => {
            if (mealItem.day === "WEEKDAY") {
                let foodOptions = !_.isEmpty(mealItem.mealOptions) ? mealItem.mealOptions : [];
                foodOptions.splice(index, 1);
                mealItem.mealOptions = foodOptions;
            }
        })
        this.props.onDataChange(mealItems)
    }

    onWeekdayFoodOptionsChange = (updatedFoodOptions: {item: IDietRecallFoodOption[]}, index: number) => {
        updatedFoodOptions.item.forEach(item => {
            if(!item.value.consumptionUnit || _.isNil(item.value.consumptionUnit.unit)) {
                item.value.consumptionUnit = {
                    unit: item.value.unit,
                    unitDetails: item.value.unitDetails
                }
            }
        })
        let mealItems = [ ...this.props.item ];
        _.map(mealItems, (mealItem) => {
            if (mealItem.day === "WEEKDAY") {
                let mealOptions = !_.isEmpty(mealItem.mealOptions) ? mealItem.mealOptions : [];
                mealOptions[index] = { foodOptions: updatedFoodOptions.item };
                mealItem.mealOptions = mealOptions;
            }
        })
        this.props.onDataChange(mealItems)
    }

    onWeekendFoodOptionsRemove = (index: number) => {
        let mealItems = [ ...this.props.item ];
        _.map(mealItems, (mealItem) => {
            if (mealItem.day === "WEEKEND") {
                let foodOptions = !_.isEmpty(mealItem.mealOptions) ? mealItem.mealOptions : [];
                foodOptions.splice(index, 1);
                mealItem.mealOptions = foodOptions;
            }
        })
        this.props.onDataChange(mealItems)
    }

    onWeekendFoodOptionsChange = (updatedFoodOptions: {item: IDietRecallFoodOption[]}, index: number) => {
        updatedFoodOptions.item.forEach(item => {
            if(!item.value.consumptionUnit || _.isNil(item.value.consumptionUnit.unit)) {
                item.value.consumptionUnit = {
                    unit: item.value.unit,
                    unitDetails: item.value.unitDetails
                }
            }
        })
        let mealItems = [ ...this.props.item ];
        _.map(mealItems, (mealItem) => {
            if (mealItem.day === "WEEKEND") {
                let foodOptions = !_.isEmpty(mealItem.mealOptions) ? mealItem.mealOptions : [];
                foodOptions[index] = { foodOptions: updatedFoodOptions.item };
                mealItem.mealOptions = foodOptions;
            }
        })
        this.props.onDataChange(mealItems)
    }

    generateFoodOptions = (mealDay: string) => {
        let foodOptions: { item: IDietRecallFoodOption[] }[] = [];
        let mealItems = [ ...this.props.item ];
        _.map(mealItems, (mealItem) => {
            if (mealItem.day === mealDay) {
                _.map(mealItem.mealOptions, (mealOption) => {
                    foodOptions.push({ item: mealOption.foodOptions });
                })
            }
        })
        return foodOptions;
    }

    getMealTypeDisplayValue = (mealType: string) => {
        let displayValue = mealType;
        if (!_.isEmpty(AppConstants.DietRecallMealSlots.filter(item => item.internalValue === mealType)))
            displayValue = AppConstants.DietRecallMealSlots.filter(item => item.internalValue === mealType)[0].displayValue;
        return displayValue;
    }

    render() {
        let mealName = !_.isEmpty(this.props.item[0].mealType) ? this.getMealTypeDisplayValue(this.props.item[0].mealType) : "";
        let insight = !_.isEmpty(this.props.item[0].insight) ? this.props.item[0].insight : "";
        let weekdayTime = this.getMealTime(MEAL_DAYS.WEEKDAY);
        let weekendTime = this.getMealTime(MEAL_DAYS.WEEKEND);
        let foodOptions = !_.isEmpty(this.props.item[0].mealOptions) ? this.props.item[0].mealOptions : [];
        let optionsToDisplay = AppConstants.DietRecallMealSlots.filter(mealSlot => 
            _.size(this.props.allSelectedMealSlots) > 0 
            ? this.props.allSelectedMealSlots.map(mealSlot => mealSlot.mealType).indexOf(mealSlot.internalValue) < 0  
            : true)
        // let time = !_.isEmpty(this.props.item.time) ? this.props.item.time : null;
        return (
            <div className="diet-recall-item-editor" >
                <div className={"diet-recall-item-editor-name"}>
                    <div className={"diet-recall-item-editor-name-label diet-recall-label"}>Meal Name</div>
                    <div className={"diet-recall-item-editor-name-value diet-recall-value"}>
                        {/*<TextInput name={"diet-recall-name"} onChange={this.updateMealName} value={mealName} />*/}
                        <CustomSelect dropdownValues={optionsToDisplay} selectedValue={mealName} defaultValue={"Select"} updateDropdownValue={this.updateMealName}/>
                    </div>
                </div>
                {
                    !_.isEmpty(mealName) &&
                    <div className={"diet-recall-item-editor-header"}>
                        <div className={"diet-recall-item-editor-name-label diet-recall-label"}></div>
                        <div className={"diet-recall-item-editor-time-value diet-recall-value weekday-value weekday-header brandon-bold"}>
                            WEEKDAYS
                        </div>
                        <div className={"diet-recall-item-editor-time-value diet-recall-value weekend-value weekend-header brandon-bold"}>
                            WEEKENDS
                        </div>
                    </div>
                }
                {
                    !_.isEmpty(mealName) &&
                    <div className={"diet-recall-item-editor-time"}>
                        <div className={"diet-recall-item-editor-time-label diet-recall-label"}>Time of Meal</div>
                        <div className={"diet-recall-item-editor-time-value diet-recall-value weekday-value"}>
                            <TimePicker supportMeridiem={false} value={AppUtils.getReadableTimeFromSeconds(weekdayTime)} onTimeChange={(time: string) => this.updateMealTime(time, MEAL_DAYS.WEEKDAY)} />
                        </div>
                        <div className={"diet-recall-item-editor-time-value diet-recall-value weekend-value"}>
                            <TimePicker supportMeridiem={false} value={AppUtils.getReadableTimeFromSeconds(weekendTime)} onTimeChange={(time: string) => this.updateMealTime(time, MEAL_DAYS.WEEKEND)} />
                        </div>
                    </div>
                }
                {
                    !_.isEmpty(mealName) &&
                    <div className={"diet-recall-item-editor-foodOptions"}>
                        <div className={"diet-recall-item-editor-foodOptions-label diet-recall-label"}>Food Options</div>
                        <div className={"diet-recall-item-editor-foodOptions-value diet-recall-value weekday-value"}>
                            <TemplatedList templateName={"foodOptions"} commonProps={{fetchStaticDishes: this.props.fetchDishByDishName}}
                                           defaultItem={{item: []}}
                                           listItems={this.generateFoodOptions("WEEKDAY")}
                                           onItemRemove={this.onWeekdayFoodOptionsRemove}
                                           onItemChange={this.onWeekdayFoodOptionsChange}/>
                        </div>
                        <div className={"diet-recall-item-editor-foodOptions-value diet-recall-value weekend-value"}>
                            <TemplatedList templateName={"foodOptions"} commonProps={{fetchStaticDishes: this.props.fetchDishByDishName}}
                                           defaultItem={{item: []}}
                                           listItems={this.generateFoodOptions("WEEKEND")}
                                           onItemRemove={this.onWeekendFoodOptionsRemove}
                                           onItemChange={this.onWeekendFoodOptionsChange}/>
                        </div>
                    </div>
                }
                {
                    !_.isEmpty(mealName) &&
                    <div className={"diet-recall-item-editor-insight"}>
                        <div className={"diet-recall-item-editor-insight-label diet-recall-label"}>Insight</div>
                        <div className={"diet-recall-item-editor-insight-value diet-recall-value"}>
                            <TextInput name={"diet-recall-insight"} value={insight} onChange={this.updateInsight} />
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default DietRecallItemEditor;